import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	id: () => faker.string.uuid(),
	creationDate: () => new Date().toISOString(),
	operationType: () => '65',
	description: () => faker.lorem.words(2),
	status: () => '0' + String(faker.number.int({ min: 1, max: 7 })),
	statusDescription: () => faker.lorem.words(1),
	signatureDate: () => new Date().toISOString(),
	expirationDate: () => new Date().toISOString(),
	sessionId: () => faker.string.uuid(),
	data: '{"amount":1.0,"origin":"0395","fee":0.0,"productId":"c739fd9f-bfc9-2ba6-a2b2-2bcbfa0a5d3a","card":"428162******0194","holder":"MIGUEL","account":"ES9402348000082000476925"}',
	secondaryOtp: faker.datatype.boolean(),
	relatedOperations: [
		{
			id: faker.string.uuid(),
			userId: '49a4f870-f30d-4d73-881f-4aa6f1a67ae2',
			name: faker.person.firstName(),
			firstSurname: faker.person.lastName(),
			secondSurname: faker.person.lastName(),
			data: '{"amount":1.0,"origin":"0395","fee":0.0,"productId":"c739fd9f-bfc9-2ba6-a2b2-2bcbfa0a5d3a","card":"428162******0194","holder":"MIGUEL","account":"ES9402348000082000476925"}',
			documentId: faker.string.alphanumeric({ length: 9, casing: 'upper' }),
			creationDate: faker.date.recent({ days: 10 }).toISOString(),
			operationType: faker.number.int({ min: 1000, max: 9999 }).toString(),
			description: faker.lorem.words({ min: 2, max: 4 }),
			status: faker.helpers.arrayElement(['01', '02', '03', '04', '05', '06', '07']),
			statusDescription: faker.helpers.arrayElement(['PENDING', 'SIGNED', 'REJECTED']),
			signatureDate: faker.date.soon({ days: 1 }).toISOString(),
			expirationDate: faker.date.soon({ days: 5 }).toISOString(),
			isSecondaryOtp: faker.datatype.boolean(),
		},
		{
			id: faker.string.uuid(),
			userId: '49a4f870-f30d-4d73-881f-4aa6f1a67ae2',
			name: faker.person.firstName(),
			firstSurname: faker.person.lastName(),
			secondSurname: faker.person.lastName(),
			data: '{"amount":1.0,"origin":"0395","fee":0.0,"productId":"c739fd9f-bfc9-2ba6-a2b2-2bcbfa0a5d3a","card":"428162******0194","holder":"MIGUEL","account":"ES9402348000082000476925"}',
			documentId: faker.string.alphanumeric({ length: 9, casing: 'upper' }),
			creationDate: faker.date.recent({ days: 10 }).toISOString(),
			operationType: faker.number.int({ min: 1000, max: 9999 }).toString(),
			description: faker.lorem.words({ min: 2, max: 4 }),
			status: faker.helpers.arrayElement(['01', '02', '03', '04', '05', '06', '07']),
			statusDescription: faker.helpers.arrayElement(['PENDING', 'SIGNED', 'REJECTED']),
			signatureDate: faker.date.soon({ days: 1 }).toISOString(),
			expirationDate: faker.date.soon({ days: 5 }).toISOString(),
			isSecondaryOtp: faker.datatype.boolean(),
		},
	],
	notifications: [
		{
			creationDate: () => new Date().toISOString(),
			messageText: faker.lorem.words(3),
			channel: faker.lorem.words(1),
			statusId: 'skipped',
			statusDescription: 'User invalid information, notifications disabled ',
			destination: 'somemail@bancocaminos.es',
		},
	],
});
